import { ImageProps } from 'next/image';
import { twMerge } from 'tailwind-merge';
import Link from 'next/link';
import { HTMLAttributes } from 'react';
import { IPost } from '../../models/ICategory';
import { truncateText } from '../../utils/truncateText';
import FallBackImage from './FallBackImage';

interface Props extends Partial<HTMLAttributes<HTMLElement>> {
  data: {
    post: IPost & { imageProps?: Partial<ImageProps> };
    category: { title: string; slug: string; }
    eager?: boolean;
  };
  maxDescLength?: number;
  className?: string;
  locale: string;
  device?: string;
}

export default function NewsStrip({ maxDescLength, data, className, locale, device, ...rest }: Props) {
  const { post: { title, image, thumbnail, imageProps, uniqueCode, imageAlt }, category } = data;
  const formattedTitle = truncateText(title ?? '', maxDescLength ?? 200);

  return (
    <Link hrefLang={locale} title={data.post.title} {...rest} href={`/${category?.slug}/${uniqueCode}`} className={twMerge('flex box-content items-start justify-start overflow-y-hidden bg-white h-[85px] tablet:h-[104px] desktop:h-[108px] p-[2.5px] w-full transition-all duration-[500] hover:cursor-pointer rounded-[24px] gap-x-[14px]', className)} dir='rtl'>
      <div className={twMerge('h-full relative overflow-hidden flex-shrink-0 rounded-tr-[inherit] rounded-br-[inherit] rounded-tl-[8px] rounded-bl-[8px] aspect-square')}>
        <FallBackImage device={device} src={image} thumbnail={thumbnail} sizes='100vw' fill eager={data.eager} {...imageProps} alt={imageAlt || ''} className={twMerge('object-cover rounded-[inherit]', imageProps?.className)} />
      </div>
      <div className='[&>*]:text-primary-300 flex flex-col h-full justify-center py-[8px] pl-[16px]'>
        <h3 className='line-clamp-3 h6'>{formattedTitle}</h3>
      </div>
    </Link>
  )
}